import { styled } from "@vitality-ds/system";
import BaseHeaderCellStyles from "./styles/BaseHeaderCell.styles";

// eslint-disable-next-line import/prefer-default-export
export var BaseHeaderCell = styled("div", BaseHeaderCellStyles);